module.exports = __webpack_public_path__ + "img/icon_node_ecosystem.c8496c3.png";